export const ADD_REVIEW = "ADD_REVIEW";
export const EDIT_REVIEW = "EDIT_REVIEW";
export const SET_REVIEWS = "SET_REVIEWS"